import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_LISTING_RECEIVE,
  PRODUCT_LISTING_SET_PROP,
  PRODUCT_LISTING_SET_IS_LOADING,
  PRODUCT_LISTING_SET_PRODUCTS,
  PRODUCT_LISTING_SET_NUMBER_TO_LOAD
} from '../constants';
import { AnyAction } from 'redux';
import { ReactElement } from 'react';

export enum ProductListingType {
  Grid = 'Grid',
  List = 'List',
  SingleCard = 'SingleCard',
}

export interface ProductListingState {
  canLoadMore: boolean;
  pageSize: number;
  products: any[];
  productsPerRow: number;
  productListingType: ProductListingType;
  totalProductsCount: number;
  isLoadingMore: boolean;
  isLoadingReverse: boolean;
  isLoading: boolean;
  ProductComponent?: ReactElement;
  ProductPlaceholderComponent?: ReactElement;
  gtmViewModel?: any;
  productsPerLoadDropdownValue?: number;
  clickSource?: string;
}

const defaultState: ProductListingState = {
  canLoadMore: true,
  pageSize: 12,
  products: [],
  productsPerRow: 4,
  productListingType: ProductListingType.Grid,
  totalProductsCount: 0,
  isLoadingMore: false,
  isLoadingReverse: false,
  isLoading: false,
  productsPerLoadDropdownValue: 0,
};

export const productListing = (
  state = defaultState,
  action: AnyAction
): ProductListingState => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_LISTING_RECEIVE:
    case PRODUCT_LISTING_SET_PROP:
    case PRODUCT_LISTING_SET_IS_LOADING:
      return {
        ...state,
        ...payload,
      };
    case PRODUCT_LISTING_SET_PRODUCTS:
      return {
        ...state,
        ...payload,
      };
    case PRODUCT_FILTERING_RECEIVE:
      return {
        ...state,
        ...payload.productListing,
      };
    case PRODUCT_LISTING_SET_NUMBER_TO_LOAD:
      const newState = { ...state };
      newState.productsPerLoadDropdownValue = payload;
      return {
        ...newState,
      };
    default:
      return state;
  }
};
